var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _vm.$t("views.auth.createAccountButton_subscript")
      ? _c("span", { staticClass: "textIntro" }, [
          _vm._v(
            "\n\t\t" +
              _vm._s(_vm.$t("views.auth.createAccountButton_subscript")) +
              "\n\t"
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "registerButtons" }, [
      _c("div", { staticClass: "loginButtonWrapper" }, [
        _c(
          "button",
          { staticClass: "secondaryButton", on: { click: _vm.login } },
          [
            _vm._v(
              "\n\t\t\t\t" + _vm._s(_vm.$t("views.auth.login")) + "\n\t\t\t"
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "registerButtonWrapper" }, [
        _c(
          "button",
          { staticClass: "primaryButton", on: { click: _vm.signup } },
          [
            _vm._v(
              "\n\t\t\t\t" +
                _vm._s(_vm.$t("views.auth.createAccountButton")) +
                "\n\t\t\t"
            ),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.showGuest
      ? _c("div", [
          _c("div", { staticClass: "or" }, [
            _c("hr"),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                "\n\t\t\t\t" + _vm._s(_vm.$t("views.auth.or")) + "\n\t\t\t"
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "secondaryButton",
              on: { click: _vm.anonymousLogin },
            },
            [
              _vm._v(
                "\n\t\t\t" + _vm._s(_vm.$t("views.auth.guestButton")) + "\n\t\t"
              ),
            ]
          ),
          _vm._v(" "),
          _vm.$t("views.auth.guestButton_subscript")
            ? _c("span", { staticClass: "subscript" }, [
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(_vm.$t("views.auth.guestButton_subscript")) +
                    "\n\t\t"
                ),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }